import { instanceBo } from "../utils/axios.create";
import { Category, CategoryType } from "@/domain/category.interface";

/**
 * Get category by type
 */
const getCategoryByType = async (type: CategoryType): Promise<Category> => {
	return instanceBo
		.get(`/categories?type=${type}`)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

/**
 * Get category by ID
 */
const getCategoryById = async (id: string): Promise<Category> => {
	return instanceBo
		.get(`/categories/${id}`)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const categoryService = {
	getCategoryByType,
	getCategoryById,
};
